import React from 'react';
import './Products.css';
import product1 from '../../assets/images/cat-01.jpg';
import product2 from '../../assets/images/cat-02.jpg';
import product3 from '../../assets/images/cat-03.jpg';

const Products = () => {
  const products = [
    {
      id: 1,
      title: 'Гостиничные чеки',
      image: product1,
      description: 'У нас можно заказать чеки за проживание в гостинице. Вы получаете кассовый чек с QR кодом от действующей в Челябинске гостиницы. <br><br>Изготовленный на ККТ фискальный чек со 100% подтверждением как в бухгалтерии, так и на официальных онлайн сервисах nalog.ru'
    },
    {
      id: 2,
      title: 'Строительные чеки',
      image: product2,
      description: 'Мы сможем изготовить кассовые и товарные чеки на строительные материалы. Документы формируются на оборудованной кассе с уплатой налогов.<br><br>Работая официально от собственного строительного магазина, мы помогаем клиентам эффективно отчитываться по затраченным средствам.'
    },
    {
      id: 3,
      title: 'Отчетные документы для ЮЛ',
      image: product3,
      description: 'Для юридических лиц мы оформляем все необходимые отчетные документы: счет фактуру, акт, УПД на стройматериалы или проживание. <br><br>Корпоративные клиенты обращаются что бы отчитаться по затраченным средствам, которые вносились в кассу наличкой или картой.'
    }
  ];

  return (
    <section className="products section">
      <div className="container">
        {/* Заголовок "Изготовливаем:" */}
        <h2 className="products__title">Изготовливаем:</h2>
        
        {/* Карточки продуктов */}
        <div className="products__grid">
          {products.map(product => (
            <div key={product.id} className="product-card">
              <div className="product-card__body">
                <div className="product-card__title">{product.title}</div>
                <img 
                  src={product.image} 
                  alt={product.title} 
                  className="product-card__image"
                  width="500"
                  height="333"
                />
                <div 
                  className="product-card__description"
                  dangerouslySetInnerHTML={{ __html: product.description }}
                />
              </div>
            </div>
          ))}
        </div>

        {/* Текст о конфиденциальности */}
        <div className="products__confidentiality">
          <div className="confidentiality__text">
            Мы строго соблюдаем конфиденциальность на всех этапах взаимодействия с клиентом. 
            Во внутренних базах компании ваше обращение отражается как обычное клиентское посещение 
            в указанные даты, будь это проживание в гостинице или закупка в строительном магазине. 
            При этом чеки и иные документы проводятся в соответствии с законодательством, 
            включая уплату налогов, поэтому мы гарантируем 100% подтверждение и отсутствие 
            проблем со сдачей отчета.
          </div>
        </div>
      </div>
    </section>
  );
};

export default Products;